import controller from './list-results.controller';
import template from './list-results.html';
import './list-results.scss';

export default {
	template,
	controller,
	bindings: {
		row: '=',
		showSearch: '<?',
		tab: '=?',
	},
	controllerAs: '$ctrl',
};
